import React from 'react'
import { NATIVE_APP_HELPER } from 'constants/native_app_helper.constants'
import Button, { ButtonType } from 'components/buttons/button/Button'

import styles from './HoneybadgerError.module.scss'

const handleReloadOnNative = () => {
  window.location.href = `${window.location.protocol}//${window.location.host}`
}
export const HoneybadgerError = () => {
  const isNative = NATIVE_APP_HELPER.IS_NATIVE_PLATFORM

  return (
    <div className={styles.ErrorContainer}>
      <h2>Oops! There was an error in the application.</h2>
      <p>
        We&apos;ve been notified about this issue and we&apos;ll take a look at
        it as soon as we can.
      </p>
      <p>Please try reloading the page in a moment.</p>
      {isNative && (
        <div className={styles.ReloadContainer}>
          <Button
            type={ButtonType.Secondary}
            label="Reload the app"
            buttonSize="Medium"
            onClick={handleReloadOnNative}
          />
        </div>
      )}
    </div>
  )
}
